__turbopack_context__.v({
  "anchor": "Heading-module-scss-module__m5BMOW__anchor",
  "h1": "Heading-module-scss-module__m5BMOW__h1",
  "h2": "Heading-module-scss-module__m5BMOW__h2",
  "h3": "Heading-module-scss-module__m5BMOW__h3",
  "heading": "Heading-module-scss-module__m5BMOW__heading",
  "icon": "Heading-module-scss-module__m5BMOW__icon",
  "wrapper": "Heading-module-scss-module__m5BMOW__wrapper",
});
